var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00023 0.333599L8.99956 3.00001H22.9996L23.0002 0.333099L25.0002 0.333599L24.9996 3.00001H28C30.025 3.00001 31.6666 4.64163 31.6666 6.66667V28C31.6666 30.025 30.025 31.6667 28 31.6667H3.99998C1.97494 31.6667 0.333313 30.025 0.333313 28V6.66667C0.333313 4.64163 1.97494 3.00001 3.99998 3.00001H6.99956L7.00023 0.333099L9.00023 0.333599ZM22.9991 5.00001L22.9984 7.66643L24.9984 7.66693L24.9991 5.00001H28C28.9205 5.00001 29.6666 5.7462 29.6666 6.66667V11H2.33331V6.66667C2.33331 5.7462 3.0795 5.00001 3.99998 5.00001H6.99906L6.9984 7.66643L8.9984 7.66693L8.99906 5.00001H22.9991ZM29.6666 13V28C29.6666 28.9205 28.9205 29.6667 28 29.6667H3.99998C3.0795 29.6667 2.33331 28.9205 2.33331 28V13H29.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e82f768d107915d9e7698ab0f9d8dd8c.svg";
export { ForwardRef as ReactComponent };